import { VueFunnelGraph } from 'vue-funnel-graph-js';

export default {
  extends: VueFunnelGraph,
  mounted() {
    this.$el.innerHTML += `
      <style>
        .label__value {
          color:  ${this.$vuetify.theme.currentTheme.colorPrimary1} !important;
        }
        .label__title {
          color: ${this.$vuetify.theme.currentTheme.colorPrimary2} !important;
        }
        .label__percentage {
          color: ${this.$vuetify.theme.currentTheme.colorPrimary4} !important;
        }
      </style>
    `;
  }
}